import React from 'react';
import ConsultantCard from '../ConsultantCard/ConsultantCard';
import { GridItem, GridReveal } from '../UI/Grid/Grid';
import Section from '../UI/Section/Section';

const ConsultantSection = ({ heading, sectionProps, nodes, ...other }) => {
  return !!nodes.length ? (
    <Section heading={heading} {...sectionProps}>
      <GridReveal>
        {nodes?.map(
          ({ id, title, uri, consultantDetails, specialityTags }) => {
            return (
              <GridItem md={4} lg={3} xl={3} key={id}>
                <ConsultantCard
                  {...consultantDetails}
                  title={title}
                  specialities={specialityTags}
                  path={uri}
                />
              </GridItem>
            );
          }
        )}
      </GridReveal>
    </Section>
  ) : null;
};

export default ConsultantSection;
